import { useQuery } from "@tanstack/react-query";
import { Sparkles, HeartHandshake } from "lucide-react";
import { retentionWhatsNew } from "../../lib/api";
import { tr } from "../../lib/i18n";

// Shown to members coming back after a cancellation (win-back link or re-subscribe): vault intact + what changed while they were away.
export const WelcomeBack = ({ force = false, compact = false }) => {
  const { data } = useQuery({ queryKey: ["whats-new"], queryFn: retentionWhatsNew, staleTime: 300_000 });
  if (!data || (!force && !data.returning)) return null;
  const since = data.away_since ? new Date(data.away_since).toLocaleDateString(undefined, { month: "long", year: "numeric" }) : null;
  return (
    <section data-testid="welcome-back" className={`rounded-2xl border border-primary/30 bg-primary/5 ${compact ? "p-4" : "p-5 sm:p-6"} text-left`}>
      <div className="flex items-start gap-3">
        <span className="h-10 w-10 rounded-xl bg-primary text-primary-foreground grid place-items-center shrink-0"><HeartHandshake className="h-5 w-5" /></span>
        <div className="min-w-0">
          <h2 className="font-serif text-xl sm:text-2xl">{tr("Welcome back")}</h2>
          <p className="text-sm text-muted-foreground mt-1" data-testid="welcome-back-intact">
            {tr("Your vault is exactly as you left it")}{since ? ` ${tr("in")} ${since}` : ""} — {data.document_count} {tr(data.document_count === 1 ? "document, still encrypted and ready." : "documents, still encrypted and ready.")}
          </p>
          <div className="mt-3 text-[10px] uppercase tracking-widest font-mono text-primary flex items-center gap-1.5"><Sparkles className="h-3.5 w-3.5" /> {tr("What changed while you were away")}</div>
          <ul className="mt-1.5 space-y-1 text-sm" data-testid="welcome-back-items">
            {data.items.map((it) => <li key={it} className="flex gap-2"><span className="text-primary">•</span><span>{it}</span></li>)}
          </ul>
        </div>
      </div>
    </section>
  );
};
